// src/routes/AdminRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useAuthenticator } from '@aws-amplify/ui-react';
import LoadingLogo from '../components/LoadingLogo';

const AdminRoute = ({ children }) => {
  const { user, authStatus } = useAuthenticator((context) => [
    context.user,
    context.authStatus,
  ]);

  const [isAdmin, setIsAdmin] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkUserGroups = () => {
      const accessToken = sessionStorage.getItem('accessToken');
      if (!accessToken) {
        setIsAdmin(false);
        setChecking(false);
        return;
      }

      try {
        const decoded = jwtDecode(accessToken);
        const groups = decoded['cognito:groups'] || [];
        setIsAdmin(groups.includes('Admin'));
      } catch (err) {
        console.error('Erreur de décodage du token', err);
        setIsAdmin(false);
      }

      setChecking(false);
    };

    checkUserGroups();
  }, []);

  // En attente de chargement Cognito
  if (authStatus === 'configuring' || checking) {
    return <LoadingLogo />;
  }

  if (!user || !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
